import './TestOrderBillingDetailsComponent.scss';
import React, {useCallback, useEffect, useState} from 'react';
import FormTitleWithNavigationBack
    from '../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack';
import ButtonComponent from '../../../../shared/components/core/button/ButtonComponent';
import {CommonService} from '../../../../shared/services';
import {IAPIResponseType} from '../../../../shared/models/api.model';
import LoaderComponent from '../../../../shared/components/loader/loaderComponent';
import StatusCardComponent from '../../../../shared/components/status-card/statusCardComponent';
import {Grid} from '@mui/material';
import DrawerComponent from '../../../../shared/components/drawer/drawerComponent';
import InsuranceFormComponent from '../../../../shared/components/insurance-form/insuranceFormComponent';
import CheckBoxComponent from '../../../../shared/components/core/checkbox/CheckboxComponent';
import InsuranceDetailsComponent from "../../../../shared/components/insurance-details/insuranceDetailsComponent";
import _ from "lodash";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from "@mui/icons-material/Delete";
import AutoCompleteDropdownComponent
    from "../../../../shared/components/core/auto-complete-dropdown/autoCompleteDropdownComponent";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
// import useDynamicRefs from "use-dynamic-refs";
import InputComponent from "../../../../shared/components/core/input/InputComponent";
import {ImageConfig} from "../../../../constants";

interface TestOrderBillingDetailsProps {
    next: Function;
    prev: Function;
    testOrderID: number;
    testOrderDetails: any;
    cancel: Function;
    onDelete: Function;
    isDeleteLoading: boolean;
    canDiscardTestOrder: boolean;
}

type insuranceTypes = "primaryInsuranceId" | "secondaryInsuranceId" | "teritaryInsuranceId";

const getRemainingInsuranceList = (allList: any[], selectedInsuranceObj: any = {}) => {
    const remainingList: any[] = [];

    // Gather selected IDs into a Set for fast lookup
    const selectedIds = new Set<number>();

    if (selectedInsuranceObj.primaryInsuranceId) {
        selectedIds.add(selectedInsuranceObj.primaryInsuranceId);
    }
    if (selectedInsuranceObj.secondaryInsuranceId) {
        selectedIds.add(selectedInsuranceObj.secondaryInsuranceId);
    }
    if (selectedInsuranceObj.teritaryInsuranceId) {
        selectedIds.add(selectedInsuranceObj.teritaryInsuranceId);
    }

    // Filter out selected IDs from allList
    allList.forEach((insurance) => {
        if (!selectedIds.has(insurance.id)) {
            remainingList.push(insurance);
        }
    });


    return remainingList;
}

const TestOrderBillingDetailsComponent = (props: TestOrderBillingDetailsProps) => {
    const {prev, testOrderID, testOrderDetails, next, cancel, onDelete, isDeleteLoading, canDiscardTestOrder} = props;
    const [isInsuranceImageRequired, setInsuranceImageRequired] = useState(false);
    const [initialValues, setInitialValues] = useState<any>("");
    const [listSampleBillingModes, setListSampleBillingModes] = useState<any>([]);
    const [cashPaymentTestSamples, setCashPaymentTestSamples] = useState<any>([]);
    const [insurancePaymentTestSamples, setInsurancePaymentTestSamples] = useState<any>([]);
    const [isListSampleBillingModesLoading, setIsListSampleBillingModesLoading] = useState<any>(false);
    const [isListSampleBillingModesLoaded, setIsListSampleBillingModesLoaded] = useState<any>(false);
    const [isListSampleBillingModesFailed, setIsListSampleBillingModesFailed] = useState<any>(false);
    const [patientInsuranceDetailsList, setPatientInsuranceDetailsList] = useState<any>([]);
    const [isPatientInsuranceListLoading, setIsPatientInsuranceListLoading] = useState<boolean>(false);
    const [isPatientInsuranceListLoaded, setIsPatientInsuranceListLoaded] = useState<boolean>(false);
    const [isPatientInsuranceListLoadingFailed, setIsPatientInsuranceListLoadingFailed] = useState<boolean>(false);
    const [openInsuranceDrawer, setOpenInsuranceDrawer] = useState<boolean>(false);
    const [insuranceMode, setInsuranceMode] = useState<string>("")
    const [selectedInsurancesList, setSelectedInsurancesList] = useState<any[]>([]);
    const [selectedCashTestPanels, setSelectedCashTestPanels] = useState<any[]>([]);
    const [cashPanelsDisable, setCashPanelsDisable] = useState<boolean>(false);
    const [isCashPaymentSubmitting, SetIsCashPaymentSubmitting] = useState<boolean>(false);
    const [isPanelInsuranceIsSubmitting, setIsPanelInsuranceIsSubmitting] = useState<boolean>(false);
    const [openInsuranceViewDrawer, setOpenInsuranceViewDrawer] = useState<boolean>(false);
    // const [consentFormList, setConsentFormList] = useState<any[]>([]);
    // const [consentFormFile, setConsentFormFile] = useState<any>(undefined);
    // const [isContinueVisible, setIsContinueVisible] = useState<boolean>(false);
    // const [isConsentFormBeingUploaded, setIsConsentFormBeingUploaded] = useState<boolean>(false);
    // const [showConsentFormPreviewDialog, setShowConsentFormPreviewDialog] = useState<boolean>(false);
    // const [isNewConsentForm, setNewConsentForm] = useState<boolean>(false)

    const [insurancesSelectedForAllPanels, setInsurancesSelectedForAllPanels] = useState<boolean>(false);
    // const [currentPanel, setCurrenPanel] = useState<any>(null);

    // const [isSendFormLinkToPatientLoading, setIsSendFormLinkToPatientLoading] = useState<boolean>(false);

    // const [getRef, setRef] = useDynamicRefs();

    const getListSampleBillingModes = useCallback(() => {
        setIsListSampleBillingModesLoading(true);
        setIsListSampleBillingModesFailed(false);
        setIsListSampleBillingModesLoaded(false);
        const payload = {}
        let listSampleBillingModes: any = [];
        let cashPaymentTestSamples: any = [];
        let insurancePaymentTestSamples: any = [];
        CommonService._testOrder.getTestOrderListSampleBillingModes(testOrderID, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    listSampleBillingModes = response.data;
                }
                cashPaymentTestSamples = listSampleBillingModes.filter((sample: any) => sample.billingMode === "cash");
                insurancePaymentTestSamples = listSampleBillingModes.filter((sample: any) => sample.billingMode === "insurance");
                let cashReceivedForSamplesCount = 0;
                cashPaymentTestSamples.forEach((sample: any) => {
                    if (sample.isPaymentCompleted) {
                        cashReceivedForSamplesCount++;
                        setSelectedCashTestPanels((oldState) => {
                            if (oldState.length === 0) {
                                return [sample.id];
                            } else {
                                return [...oldState, sample.id];
                            }
                        });
                    }
                });
                if (cashReceivedForSamplesCount === cashPaymentTestSamples.length) {
                    setCashPanelsDisable(true);
                }

                insurancePaymentTestSamples.forEach((sample: any, panelIndex: number) => {
                    if (sample.isPaymentCompleted) {
                        const payload = {
                            "sampleId": sample?.id,
                            "insuranceId": sample?.insuranceDetails?.insuranceId
                        };
                        setSelectedInsurancesList((oldState) => {
                            const insuranceMapping = _.cloneDeep(oldState);
                            insuranceMapping[panelIndex] = payload;
                            return insuranceMapping;
                        })
                    }
                    // const consentPayload = {
                    //     "sampleId": sample?.id,
                    //     "isConsentSigned": sample?.isConsentSigned,
                    //     "consentDetails": sample?.consentDetails
                    // };

                    // setConsentFormList((oldState) => {
                    //         const consentMapping = _.cloneDeep(oldState);
                    //         consentMapping[panelIndex] = consentPayload;
                    //         return consentMapping;
                    //     }
                    // )
                    //Dynamic refs
                    // setRef(sample?.id);
                })

                if (cashPaymentTestSamples.length === 0) {
                    setCashPanelsDisable(true);
                }

                setListSampleBillingModes(listSampleBillingModes);
                setCashPaymentTestSamples(cashPaymentTestSamples);
                setInsurancePaymentTestSamples(insurancePaymentTestSamples);
                setIsListSampleBillingModesLoading(false);
                setIsListSampleBillingModesFailed(false);
                setIsListSampleBillingModesLoaded(true);
            })
            .catch((error: any) => {
                setListSampleBillingModes(listSampleBillingModes);
                setCashPaymentTestSamples(cashPaymentTestSamples);
                setInsurancePaymentTestSamples(insurancePaymentTestSamples);
                setIsListSampleBillingModesLoading(false);
                setIsListSampleBillingModesFailed(true);
                setIsListSampleBillingModesLoaded(false);
            });
    }, [testOrderID])

    useEffect(() => {
        getListSampleBillingModes();
    }, [testOrderID, getListSampleBillingModes]);

    const getPatientInsuranceList = useCallback(() => {
        setIsPatientInsuranceListLoading(true);
        setIsPatientInsuranceListLoaded(false);
        setIsPatientInsuranceListLoadingFailed(false);
        const payload = {}
        CommonService._patient.getPatientInsuranceList(testOrderDetails.patientId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    const sortedList = CommonService.sortPatientInsuranceList(response.data);
                    setPatientInsuranceDetailsList(sortedList);
                } else {
                }
                setIsPatientInsuranceListLoading(false);
                setIsPatientInsuranceListLoaded(true);
                setIsPatientInsuranceListLoadingFailed(false);
            })
            .catch((error: any) => {
                setIsPatientInsuranceListLoading(false);
                setIsPatientInsuranceListLoaded(false);
                setIsPatientInsuranceListLoadingFailed(true);
            });
    }, [testOrderDetails]);

    const onSelectedCashTestPanelsReceived = useCallback(() => {
        SetIsCashPaymentSubmitting(true);
        CommonService._testOrder.addTestOrderSampleCashPaymentList(testOrderID, {"samples": selectedCashTestPanels})
            .then((response: IAPIResponseType<any>) => {
                SetIsCashPaymentSubmitting(false);
                setCashPanelsDisable(true);
                CommonService._alert.showToast(response?.message || 'payment has been received', "success");
            })
            .catch((error: any) => {
                SetIsCashPaymentSubmitting(false);
                CommonService._alert.showToast(error?.message || 'Failed to receive Payment', "error");
            });
    }, [selectedCashTestPanels, testOrderID]);

    const onInsuranceSelect = useCallback((insuranceID: any, type: insuranceTypes, sampleID: any, panelIndex: any) => {
        const oldPayload = selectedInsurancesList[panelIndex] || {}
        const payload = {
            ...oldPayload,
            "sampleId": sampleID,
            [type]: insuranceID,
        };
        if (insuranceID === null || insuranceID === undefined) {
            setSelectedInsurancesList((oldState) => {
                const insuranceMapping = _.cloneDeep(oldState);
                if (type === "primaryInsuranceId") {
                    insuranceMapping[panelIndex]["primaryInsuranceId"] = null;
                    insuranceMapping[panelIndex]["secondaryInsuranceId"] = null;
                    insuranceMapping[panelIndex]["teritaryInsuranceId"] = null;
                    insuranceMapping[panelIndex]["note"] = null;
                } else if (type === "secondaryInsuranceId") {
                    insuranceMapping[panelIndex]["secondaryInsuranceId"] = null;
                    insuranceMapping[panelIndex]["teritaryInsuranceId"] = null;
                } else if (type === "teritaryInsuranceId") {
                    insuranceMapping[panelIndex]["teritaryInsuranceId"] = null;
                }
                // insuranceMapping[panelIndex][type] = null;
                return insuranceMapping;
            })
        } else {
            setSelectedInsurancesList((oldState) => {
                const insuranceMapping = _.cloneDeep(oldState);
                insuranceMapping[panelIndex] = payload;
                return insuranceMapping;
            })
        }
    }, [selectedInsurancesList]);
    const handleNoteValue = useCallback((panelIndex: number, mode: 'view' | 'edit', text?: string) => {
        if (mode === 'view') {
            return selectedInsurancesList[panelIndex]?.note || "";
        } else {
            const oldPayload = selectedInsurancesList[panelIndex] || {};
            const payload = {
                ...oldPayload,
                note: text || ''
            };

            setSelectedInsurancesList((oldState) => {
                const insuranceMapping = _.cloneDeep(oldState);
                insuranceMapping[panelIndex] = payload;
                return insuranceMapping;
            })
        }
    }, [selectedInsurancesList])

    useEffect(() => {
        if (selectedInsurancesList) {
            let count = 0;
            selectedInsurancesList.forEach((insurance: any) => {
                if (![null, undefined, ''].includes(insurance?.primaryInsuranceId)) {
                    count++;
                }
            })
            if (count === insurancePaymentTestSamples.length) {
                setInsurancesSelectedForAllPanels(true);
            } else {
                setInsurancesSelectedForAllPanels(false);
            }
        }
    }, [selectedInsurancesList, insurancePaymentTestSamples])

    const onUpdateComplete = useCallback((data: any) => {
        if (insuranceMode === 'add') {
            setPatientInsuranceDetailsList((oldState: any) => {
                if (oldState?.length > 0) {
                    return [data, ...oldState]
                } else {
                    return [data]
                }
            });
        }
        if (insuranceMode === 'edit') {
            const temporaryList = _.cloneDeep(patientInsuranceDetailsList);
            const index = temporaryList.findIndex((insuranceDetails: any) => {
                return insuranceDetails.id === data.id;
            });
            temporaryList[index] = data;
            setPatientInsuranceDetailsList(temporaryList);
        }
        setInitialValues("");
        setOpenInsuranceDrawer(false);
    }, [insuranceMode, patientInsuranceDetailsList]);

    const handleInsuranceDrawer = useCallback((insuranceMode: any, insurance?: any) => {
        if (insuranceMode === 'edit') {
            setInitialValues(insurance);
            setOpenInsuranceDrawer(true);
            setInsuranceMode('edit');
        }
        if (insuranceMode === 'add') {
            setOpenInsuranceDrawer(true);
            setInsuranceMode('add');
        }
        if (insuranceMode === 'view') {
            setInitialValues(insurance);
            setOpenInsuranceViewDrawer(true);
        }

    }, []);

    const submitPanelInsurance = useCallback(() => {
        setIsPanelInsuranceIsSubmitting(true);
        if (selectedInsurancesList.length === 0) {
            next();
            setIsPanelInsuranceIsSubmitting(false);
        }
        CommonService._testOrder.submitPanelInsurance(testOrderID, {"data": selectedInsurancesList})
            .then((response: IAPIResponseType<any>) => {
                setIsPanelInsuranceIsSubmitting(false);
                next();
            })
            .catch((error: any) => {
                setIsPanelInsuranceIsSubmitting(false);
                CommonService._alert.showToast(error?.message || 'Error uploading TestOrder Sample CashPayments', "error");
            });
    }, [testOrderID, next, selectedInsurancesList]);

    useEffect(() => {
        if (testOrderDetails?.patientId && insurancePaymentTestSamples.length > 0) {
            getPatientInsuranceList();
        }
    }, [testOrderDetails, insurancePaymentTestSamples, testOrderID, getPatientInsuranceList]);

    useEffect(() => {
        CommonService._facility.getFacilityDetails(testOrderDetails?.facilityDetails?.id, {})
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    // response.data;
                    setInsuranceImageRequired(response?.data?.isInsuranceImageRequired)
                }
            })
            .catch((error: any) => {
            });
    }, [testOrderDetails?.facilityDetails?.id]);

    const onCashSampleUpdate = useCallback((value: any, sampleDetails: any) => {
        if (value) {
            setSelectedCashTestPanels((oldState) => {
                if (oldState.length === 0) {
                    return [sampleDetails.id];
                } else {
                    return [...oldState, sampleDetails.id];
                }
            });
        } else {
            setSelectedCashTestPanels((oldState) => {
                    return (oldState.filter(code => code !== sampleDetails.id));
                }
            );
        }
    }, []);

    const handleInsuranceDrawerClose = useCallback(() => {
        setInitialValues("");
        setOpenInsuranceDrawer(false);
    }, []);

    const handleInsuranceViewDrawerClose = useCallback(() => {
        setInitialValues("");
        setOpenInsuranceViewDrawer(false);
    }, []);

    // const handleTemplateAttachmentUpload = useCallback((event: any) => {
    //     const file = event?.target?.files[0];
    //     const maxAllowedSize = 5 * 1024 * 1024;
    //     if (event?.target?.files[0].size > maxAllowedSize) {
    //         CommonService._alert.showToast('File size should be under 5MB.', "error");
    //         event.target.value = null;
    //         event.target.files = null;
    //         return;
    //     }
    //     event.target.value = null;
    //     event.target.files = null;
    //     setIsContinueVisible(true);
    //     setShowConsentFormPreviewDialog(true);
    //     setConsentFormFile(file);
    //     setNewConsentForm(true);
    // }, []);
    //
    // const handleConsentFormSuccess = useCallback((response: any) => {
    //     setIsConsentFormBeingUploaded(false);
    //     setShowConsentFormPreviewDialog(false);
    //     setNewConsentForm(false);
    // }, []);

    // const onConsentFormSubmit = useCallback(() => {
    //     const formData = new FormData();
    //     if (consentFormFile) {
    //         formData.append('file', consentFormFile);
    //     }
    //     setIsConsentFormBeingUploaded(true);
    //     CommonService._testOrder.addConsentForm(testOrderID, currentPanel?.id, formData)
    //         .then((response: IAPIResponseType<any>) => {
    //             setConsentFormList((oldState: any) => {
    //                 const updatedList = _.cloneDeep(oldState);
    //                 const index = updatedList.findIndex((item: any) => item.sampleId === currentPanel.id);
    //                 updatedList[index].isConsentSigned = true;
    //                 updatedList[index].consentDetails = response.data;
    //                 return updatedList;
    //             })
    //             handleConsentFormSuccess(response);
    //         })
    //         .catch((error: any) => {
    //             CommonService._alert.showToast(error?.message || 'Error uploading lab attachment', "error");
    //             setIsConsentFormBeingUploaded(false);
    //         })
    // }, [consentFormFile, testOrderID, currentPanel, handleConsentFormSuccess]);


    const getInsurance = useCallback((id: any) => {
        return patientInsuranceDetailsList.find((item: any) => item.id === id);
    }, [patientInsuranceDetailsList]);

    const checkInsuranceAttachment = useCallback((selectedInsurance: any, type: insuranceTypes, sampleID: any, panelIndex: any) => {
        const isFrontImageAvailable = selectedInsurance?.frontImage?.attachmentUrl;
        const isBackImageAvailable = selectedInsurance?.backImage?.attachmentUrl;
        if (!isFrontImageAvailable || !isBackImageAvailable) {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Insurance Images Required',
                confirmationSubTitle: 'As per facility requirements, both sides of the insurance card must be uploaded to proceed.',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.ConfirmationImage}`,
                direction: "up",
                yes: {
                    text: "Upload Images",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "secondary"
                }
            })
                .then(() => {
                    handleInsuranceDrawer("edit", selectedInsurance);
                }).catch(() => {
                onInsuranceSelect(null, type, sampleID, panelIndex)
            }).finally(() => {
                onInsuranceSelect(null, type, sampleID, panelIndex)
            })
        }
    }, [handleInsuranceDrawer, onInsuranceSelect])

    // const handleConsentFormDelete = useCallback((sampleId: any) => {
    //     const payload = {};
    //     CommonService._testOrder.deleteConsentForm(testOrderID, sampleId, payload)
    //         .then((response: IAPIResponseType<any>) => {
    //             setConsentFormList((oldState: any) => {
    //                 const updatedList = _.cloneDeep(oldState);
    //                 const index = updatedList.findIndex((item: any) => item.sampleId === sampleId);
    //                 updatedList[index].isConsentSigned = false;
    //                 updatedList[index].consentDetails = null;
    //                 return updatedList;
    //             })
    //         })
    //         .catch((error: any) => {
    //                 CommonService._alert.showToast(error?.message || 'Error uploading lab attachment', "error");
    //             }
    //         )
    // }, [testOrderID]);
    //
    // const handleSendFormLinkToPatient = useCallback((sampleId: any) => {
    //     setIsSendFormLinkToPatientLoading(true);
    //     const payload = {};
    //     CommonService._testOrder.sendConsentFormLinkToPatient(testOrderID, sampleId, payload)
    //         .then((response: IAPIResponseType<any>) => {
    //                 setIsSendFormLinkToPatientLoading(false);
    //                 CommonService._alert.showToast("Consent form link sent to patient", "success");
    //             }
    //         )
    //         .catch((error: any) => {
    //                 setIsSendFormLinkToPatientLoading(false);
    //                 CommonService._alert.showToast(error?.message || 'Error Sending Consent Form Link to Patient', "error");
    //             }
    //         )
    // }, [testOrderID]);

    return (
        <div className="test-order-billing-details-screen screen t-form-screen">
            <div className="d-flex align-items-center justify-content-space-between">
                <FormTitleWithNavigationBack
                    title={'Billing Details'}
                    tooltipData={"For multiple panels, cash and card payments are combined. Mark the paid ones in them seperately. Insurance will be applied to each panel individually."}
                    handleClick={prev}
                />
                <div className="mrg-right-30 mrg-top-20">
                    {
                        canDiscardTestOrder &&
                        <ButtonComponent
                            startIcon={<DeleteIcon/>}
                            variant={"outlined"}
                            color={'primary'}
                            fullWidth={false}
                            handleClick={onDelete}
                            isLoading={isDeleteLoading}
                        >Discard Test Order</ButtonComponent>
                    }
                </div>
            </div>

            <div className="t-form t-form-back-navigation">
                <form>
                    <div className="t-form-controls-wrapper">
                        {
                            isListSampleBillingModesLoading && <>
                                <LoaderComponent/>
                            </>
                        }
                        {
                            isListSampleBillingModesFailed && <>
                                <StatusCardComponent title={"Billing details  failed to load"}/>
                            </>
                        }
                        {isListSampleBillingModesLoaded && <>
                            {listSampleBillingModes?.length > 0 ?
                                <>
                                    {cashPaymentTestSamples.length > 0 &&
                                        <div className="billing-details-body">
                                            <div className="billing-details-title">Cash Payment</div>
                                            <div className={'card-content'}>
                                                <div className="samples-list-wrapper">
                                                    <div className="panel-name-title billing-details-panel-name">Test
                                                        Name(s):
                                                    </div>
                                                    {
                                                        cashPaymentTestSamples?.map((sampleDetails: any) => {
                                                            return (
                                                                <div
                                                                    key={sampleDetails?.name + "-" + sampleDetails?.id}>
                                                                    <CheckBoxComponent name={"name"}
                                                                                       disabled={cashPanelsDisable}
                                                                                       label={sampleDetails?.testDetails?.name}
                                                                                       checked={selectedCashTestPanels?.map(sample => sample).includes(sampleDetails.id)}
                                                                                       onUpdate={(value: any) => {
                                                                                           onCashSampleUpdate(value, sampleDetails)
                                                                                       }}
                                                                    />
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={6}></Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <div className='cash-payment-recieved-button'>
                                                            <ButtonComponent
                                                                type="submit"
                                                                color={"primary"}
                                                                variant={"contained"}
                                                                fullWidth={true}
                                                                size={'small'}
                                                                isLoading={isCashPaymentSubmitting}
                                                                disabled={selectedCashTestPanels?.length !== cashPaymentTestSamples.length || cashPanelsDisable}
                                                                handleClick={onSelectedCashTestPanelsReceived}
                                                            >
                                                                Mark as Received
                                                            </ButtonComponent>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        </div>
                                    }
                                    {
                                        cashPaymentTestSamples.length > 0 && insurancePaymentTestSamples.length > 0 &&
                                        <div className="horizontal-line"/>
                                    }
                                    {insurancePaymentTestSamples.length > 0 &&
                                        <div className="billing-details-body">
                                            <div className="billing-details-title">Insurance Payment</div>

                                            {insurancePaymentTestSamples?.map((panel: any, panelIndex: any) => {
                                                // @ts-ignore
                                                return (
                                                    <div className="card-content"
                                                         key={panel?.testDetails?.name + "-" + panelIndex}>
                                                        <div className="billing-details-sample-card">
                                                            <div className='insurance-panel-header'>
                                                                <div className="panel-name-wrapper">
                                                                    <div className='panel-name-title'>
                                                                        Test Name:
                                                                    </div>
                                                                    <div
                                                                        className='insurance-panel-name mrg-left-10'>
                                                                        {CommonService.capitalize(panel?.testDetails?.name)}
                                                                    </div>
                                                                </div>

                                                                {patientInsuranceDetailsList.length < 3 &&
                                                                    <div
                                                                        className='add-insurance-button'
                                                                        onClick={() => handleInsuranceDrawer("add")}>
                                                                        Add Insurance
                                                                    </div>
                                                                }

                                                            </div>
                                                            {
                                                                isPatientInsuranceListLoading &&
                                                                <LoaderComponent/>
                                                            }
                                                            {
                                                                isPatientInsuranceListLoadingFailed &&
                                                                <StatusCardComponent
                                                                    title={'Patient insurance List failed to load'}/>
                                                            }
                                                            {isPatientInsuranceListLoaded && <>
                                                                {
                                                                    patientInsuranceDetailsList.length > 0 && <>
                                                                        <>
                                                                            <div className={'test-order-select-insurance'}>
                                                                                <div
                                                                                    className={'test-order-select-insurance-input'}>
                                                                                    <AutoCompleteDropdownComponent
                                                                                        label={'Primary Insurance'}
                                                                                        fullWidth={true}
                                                                                        required={true}
                                                                                        name={'primaryInsuranceId'}
                                                                                        valueKey={'id'}
                                                                                        // data={patientInsuranceDetailsList}
                                                                                        data={getRemainingInsuranceList(patientInsuranceDetailsList, selectedInsurancesList[panelIndex])}
                                                                                        value={getInsurance(selectedInsurancesList[panelIndex]?.primaryInsuranceId)}
                                                                                        onSelectUpdate={(value: any) => {
                                                                                            onInsuranceSelect(value?.id, 'primaryInsuranceId', panel?.id, panelIndex);
                                                                                            (value && isInsuranceImageRequired) && checkInsuranceAttachment(value, 'primaryInsuranceId', panel?.id, panelIndex)
                                                                                        }}
                                                                                        getOptionLabel={(option => (option.insuranceCompany) || '')}
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className={'test-order-select-insurance-view-button'}>
                                                                                    <ButtonComponent
                                                                                        type={'button'}
                                                                                        variant={'outlined'}
                                                                                        color={'secondary'}
                                                                                        disabled={selectedInsurancesList?.[panelIndex]?.primaryInsuranceId === null || selectedInsurancesList?.[panelIndex]?.primaryInsuranceId === undefined || selectedInsurancesList?.[panelIndex]?.primaryInsuranceId === ''}
                                                                                        startIcon={<RemoveRedEyeIcon/>}
                                                                                        handleClick={() => {
                                                                                            handleInsuranceDrawer("view", getInsurance(selectedInsurancesList[panelIndex]?.primaryInsuranceId));
                                                                                        }
                                                                                        }
                                                                                    >
                                                                                        View
                                                                                    </ButtonComponent>
                                                                                </div>
                                                                            </div>
                                                                            <div className={'test-order-select-insurance'}>
                                                                                <div
                                                                                    className={'test-order-select-insurance-input'}>
                                                                                    <AutoCompleteDropdownComponent
                                                                                        label={'Secondary Insurance'}
                                                                                        fullWidth={true}
                                                                                        name={'secondaryInsuranceId'}
                                                                                        valueKey={'id'}
                                                                                        // data={patientInsuranceDetailsList}
                                                                                        data={getRemainingInsuranceList(patientInsuranceDetailsList, selectedInsurancesList[panelIndex])}
                                                                                        value={getInsurance(selectedInsurancesList[panelIndex]?.secondaryInsuranceId)}
                                                                                        disabled={!getInsurance(selectedInsurancesList[panelIndex]?.primaryInsuranceId)}
                                                                                        onSelectUpdate={(value: any) => {
                                                                                            onInsuranceSelect(value?.id, 'secondaryInsuranceId', panel?.id, panelIndex);
                                                                                            (value && isInsuranceImageRequired) && checkInsuranceAttachment(value, 'secondaryInsuranceId', panel?.id, panelIndex)
                                                                                        }}
                                                                                        getOptionLabel={(option => (option.insuranceCompany) || '')}
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className={'test-order-select-insurance-view-button'}>
                                                                                    <ButtonComponent
                                                                                        type={'button'}
                                                                                        variant={'outlined'}
                                                                                        color={'secondary'}
                                                                                        disabled={selectedInsurancesList[panelIndex]?.secondaryInsuranceId === null || selectedInsurancesList[panelIndex]?.secondaryInsuranceId === undefined || selectedInsurancesList[panelIndex]?.secondaryInsuranceId === ''}
                                                                                        startIcon={<RemoveRedEyeIcon/>}
                                                                                        handleClick={() => {
                                                                                            handleInsuranceDrawer("view", getInsurance(selectedInsurancesList[panelIndex]?.secondaryInsuranceId));
                                                                                        }
                                                                                        }
                                                                                    >
                                                                                        View
                                                                                    </ButtonComponent>
                                                                                </div>
                                                                            </div>
                                                                            <div className={'test-order-select-insurance'}>
                                                                                <div
                                                                                    className={'test-order-select-insurance-input'}>
                                                                                    <AutoCompleteDropdownComponent
                                                                                        label={'Tertiary Insurance'}
                                                                                        fullWidth={true}
                                                                                        name={'teritaryInsuranceId'}
                                                                                        valueKey={'id'}
                                                                                        // data={patientInsuranceDetailsList}
                                                                                        data={getRemainingInsuranceList(patientInsuranceDetailsList, selectedInsurancesList[panelIndex])}
                                                                                        value={getInsurance(selectedInsurancesList[panelIndex]?.teritaryInsuranceId)}
                                                                                        disabled={!getInsurance(selectedInsurancesList[panelIndex]?.secondaryInsuranceId)}
                                                                                        onSelectUpdate={(value: any) => {
                                                                                            onInsuranceSelect(value?.id, 'teritaryInsuranceId', panel?.id, panelIndex);
                                                                                            (value && isInsuranceImageRequired) && checkInsuranceAttachment(value, 'teritaryInsuranceId', panel?.id, panelIndex)
                                                                                        }}
                                                                                        getOptionLabel={(option => (option.insuranceCompany) || '')}
                                                                                    />
                                                                                </div>
                                                                                <div
                                                                                    className={'test-order-select-insurance-view-button'}>
                                                                                    <ButtonComponent
                                                                                        type={'button'}
                                                                                        variant={'outlined'}
                                                                                        color={'secondary'}
                                                                                        disabled={selectedInsurancesList[panelIndex]?.teritaryInsuranceId === null || selectedInsurancesList[panelIndex]?.teritaryInsuranceId === undefined || selectedInsurancesList[panelIndex]?.teritaryInsuranceId === ''}
                                                                                        startIcon={<RemoveRedEyeIcon/>}
                                                                                        handleClick={() => {
                                                                                            handleInsuranceDrawer("view", getInsurance(selectedInsurancesList[panelIndex]?.teritaryInsuranceId));
                                                                                        }
                                                                                        }
                                                                                    >
                                                                                        View
                                                                                    </ButtonComponent>
                                                                                </div>
                                                                            </div>
                                                                            <div className="mrg-top-20">
                                                                                <InputComponent type={"text"}
                                                                                                name={"note"}
                                                                                                placeholder={"Enter note if any"}
                                                                                                value={handleNoteValue(panelIndex, 'view')}
                                                                                                disabled={selectedInsurancesList[panelIndex]?.primaryInsuranceId === null || selectedInsurancesList[panelIndex]?.primaryInsuranceId === undefined || selectedInsurancesList[panelIndex]?.primaryInsuranceId === ''}
                                                                                                label={'Note'}
                                                                                                id="note_input"
                                                                                                onChange={(value: string) => {
                                                                                                    handleNoteValue(panelIndex, 'edit', value)
                                                                                                }}
                                                                                />
                                                                            </div>
                                                                        </>
                                                                        {/*<div className={'consent-form-wrapper'}>*/}
                                                                        {/*    {*/}
                                                                        {/*        selectedInsurancesList[panelIndex]?.primaryInsuranceId && <>*/}
                                                                        {/*            <div className={'consent-form-title'}>*/}
                                                                        {/*                Consent Form*/}
                                                                        {/*            </div>*/}
                                                                        {/*            {*/}
                                                                        {/*                !consentFormList.find((consentForm: any) => consentForm.sampleId === panel?.id)?.isConsentSigned ? <>*/}
                                                                        {/*                        <input type={"file"}*/}
                                                                        {/*                               className={"display-none"}*/}
                                                                        {/*                            //@ts-ignore*/}
                                                                        {/*                               ref={getRef(panel?.id)}*/}
                                                                        {/*                               accept={'application/pdf'}*/}
                                                                        {/*                               onChange={(event: any) => {*/}
                                                                        {/*                                   handleTemplateAttachmentUpload(event);*/}
                                                                        {/*                               }}*/}
                                                                        {/*                        />*/}
                                                                        {/*                        <div*/}
                                                                        {/*                            className={'consent-form-buttons-wrapper'}>*/}
                                                                        {/*                            <div*/}
                                                                        {/*                                className={'consent-form-upload'}>*/}
                                                                        {/*                                <ButtonComponent*/}
                                                                        {/*                                    variant={"contained"}*/}
                                                                        {/*                                    fullWidth={false}*/}
                                                                        {/*                                    color={'secondary'}*/}
                                                                        {/*                                    handleClick={() => {*/}
                                                                        {/*                                        setCurrenPanel(panel)*/}
                                                                        {/*                                        // @ts-ignore*/}
                                                                        {/*                                        getRef(panel?.id)?.current?.click()*/}
                                                                        {/*                                    }}*/}
                                                                        {/*                                    startIcon={*/}
                                                                        {/*                                        <FileUploadIcon/>}*/}
                                                                        {/*                                    type={'button'}>*/}
                                                                        {/*                                    Upload*/}
                                                                        {/*                                </ButtonComponent>*/}
                                                                        {/*                            </div>*/}
                                                                        {/*                            <div*/}
                                                                        {/*                                className={'consent-form-or-text'}>*/}
                                                                        {/*                                OR*/}
                                                                        {/*                            </div>*/}
                                                                        {/*                            <div*/}
                                                                        {/*                                className={'consent-form-send-to-patient'}>*/}
                                                                        {/*                                <ButtonComponent*/}
                                                                        {/*                                    variant={"outlined"}*/}
                                                                        {/*                                    fullWidth={false}*/}
                                                                        {/*                                    color={'secondary'}*/}
                                                                        {/*                                    handleClick={() => {*/}
                                                                        {/*                                        handleSendFormLinkToPatient(panel.id);*/}
                                                                        {/*                                    }}*/}
                                                                        {/*                                    isLoading={isSendFormLinkToPatientLoading}*/}
                                                                        {/*                                    startIcon={*/}
                                                                        {/*                                        <SendIcon/>}*/}
                                                                        {/*                                    type={'button'}>*/}
                                                                        {/*                                    Send Form Link to*/}
                                                                        {/*                                    Patient*/}
                                                                        {/*                                </ButtonComponent>*/}
                                                                        {/*                            </div>*/}
                                                                        {/*                        </div>*/}
                                                                        {/*                    </>*/}
                                                                        {/*                    :*/}
                                                                        {/*                    <>*/}
                                                                        {/*                        <ChipComponent*/}
                                                                        {/*                            label={'Consent_Form.pdf'}*/}
                                                                        {/*                            className={'on-hover-pointer'}*/}
                                                                        {/*                            onDelete={() => {*/}
                                                                        {/*                                handleConsentFormDelete(panel.id);*/}
                                                                        {/*                            }}*/}
                                                                        {/*                            onClick={() => {*/}
                                                                        {/*                                window.open(consentFormList.find((consentForm: any) => consentForm.sampleId === panel?.id)?.consentDetails?.url, '_blank');*/}
                                                                        {/*                            }}*/}
                                                                        {/*                            icon={<AttachFile/>}*/}
                                                                        {/*                        />*/}
                                                                        {/*                    </>*/}
                                                                        {/*            }*/}
                                                                        {/*        </>*/}
                                                                        {/*    }*/}
                                                                        {/*</div>*/}
                                                                    </>
                                                                }
                                                                {patientInsuranceDetailsList.length === 0 && <>
                                                                    <div className='mrg-top-10'>No insurance
                                                                        have
                                                                        been
                                                                        added.
                                                                    </div>
                                                                </>
                                                                }
                                                            </>}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            }

                                        </div>
                                    }


                                </> : <StatusCardComponent title={"No Billing Details Found"}/>
                            } </>
                        }
                        <br/>
                    </div>
                    <div className='form-action-section'>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            fullWidth={true}
                            handleClick={cancel}
                            disabled={isPanelInsuranceIsSubmitting}
                        >
                            Close
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            color={"primary"}
                            variant={"contained"}
                            fullWidth={true}
                            handleClick={submitPanelInsurance}
                            isLoading={isPanelInsuranceIsSubmitting}
                            disabled={!(insurancesSelectedForAllPanels && cashPanelsDisable)}
                        >
                            Submit
                        </ButtonComponent>
                    </div>
                </form>
            </div>
            <DrawerComponent
                open={openInsuranceDrawer}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                className={"drawer-wrapper"}
                onClose={() => handleInsuranceDrawerClose()}
            >

                <InsuranceFormComponent
                    formInitialValues={initialValues}
                    patientID={testOrderDetails?.patientDetails?.id}
                    isInsuranceImageRequired={isInsuranceImageRequired}
                    formTitle={""}
                    insuranceMode={insuranceMode}
                    onUpdateComplete={(data: any) => onUpdateComplete(data)}
                />
            </DrawerComponent>
            <DrawerComponent
                open={openInsuranceViewDrawer}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                className={"drawer-wrapper"}
                onClose={() => handleInsuranceViewDrawerClose()}
            >
                <div className={'view-insurance-details-wrapper'}>
                    <div className={'view-insurance-details-title-action-wrapper'}>
                        <div className={'view-insurance-details-title'}>View Insurance</div>
                        <div className={'edit-insurance-button-inside-view'}>
                            <ButtonComponent
                                type={'button'}
                                variant={'text'}
                                handleClick={() => {
                                    setOpenInsuranceViewDrawer(false)
                                    handleInsuranceDrawer("edit", initialValues)
                                }}
                                startIcon={<EditIcon/>}
                            >
                                Edit Details
                            </ButtonComponent>

                        </div>
                    </div>
                    <InsuranceDetailsComponent
                        insuranceDetails={initialValues}/>
                </div>
            </DrawerComponent>
            {/*<DialogComponent open={showConsentFormPreviewDialog}*/}
            {/*                 maxWidth={'md'}*/}
            {/*                 title={'Consent Form'}*/}
            {/*                 isShowCancel={true}*/}
            {/*                 onClose={() => {*/}
            {/*                     setShowConsentFormPreviewDialog(false);*/}
            {/*                 }}*/}
            {/*                 className={"attachment-preview-dialog"}>*/}
            {/*    <div className="attachment-preview-dialog-body" id="file_preview_component">*/}
            {/*        {consentFormFile && consentFormFile?.type === 'application/pdf' ?*/}
            {/*            <PdfPreviewComponent*/}
            {/*                attachmentFile={consentFormFile}*/}
            {/*                isFile={isNewConsentForm}*/}
            {/*            />*/}
            {/*            :*/}
            {/*            <FilePreviewerComponent*/}
            {/*                attachmentFile={consentFormFile}*/}
            {/*                isFile={isNewConsentForm}/>*/}
            {/*        }*/}
            {/*    </div>*/}
            {/*    {consentFormFile && <div className="uploaded-attachment-file-name">*/}
            {/*        <span className="font-weight-bold"> Uploaded File Name:</span>*/}
            {/*        <span>{consentFormFile?.name}</span>*/}
            {/*    </div>*/}
            {/*    }*/}
            {/*    <div className="attachment-preview-dialog-footer">*/}
            {/*        <ButtonComponent variant={"outlined"}*/}
            {/*                         id="cancel_btn"*/}
            {/*                         fullWidth={true}*/}
            {/*                         color={'primary'}*/}
            {/*                         disabled={isConsentFormBeingUploaded}*/}
            {/*                         handleClick={() => {*/}
            {/*                             // @ts-ignore*/}
            {/*                             getRef(currentPanel?.id).current?.click()*/}
            {/*                         }}*/}
            {/*        >*/}
            {/*            Re-upload*/}
            {/*        </ButtonComponent>*/}
            {/*        {*/}
            {/*            isContinueVisible &&*/}
            {/*            <ButtonComponent variant={"contained"}*/}
            {/*                             id="continue_btn"*/}
            {/*                             color={"primary"}*/}
            {/*                             fullWidth={true}*/}
            {/*                             isLoading={isConsentFormBeingUploaded}*/}
            {/*                             handleClick={onConsentFormSubmit}>*/}
            {/*                Continue*/}
            {/*            </ButtonComponent>*/}
            {/*        }*/}
            {/*    </div>*/}
            {/*</DialogComponent>*/}
        </div>
    )
};
export default TestOrderBillingDetailsComponent;
